<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>

                    <!-- Row -->
                    <div class="row">

                        <div class="col-lg-12 margin-bottom-10" v-if="$root.user.tipo == 'admin'">
                            <router-link :to="{'name': $router.currentRoute.meta.options.cadastrarBotaoNome}" class="button block-mobile transparent">
                                <i class="material-icons">add</i>
                                {{$router.currentRoute.meta.options.cadastrarBotaoTexto}}
                            </router-link>
                        </div>                          
                        <!-- Dashboard Box -->
                        <div class="col-xs-12 col-xl-6 col-lg-6">
                            <p class="page-text margin-bottom-20">
                                Gerencie abaixo os usuários do aplicativo.
                            </p>
                        </div>                               
                        <div class="col-xl-12">
                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="get">
                                <div class="row right-xs">
                                    <div class="col-lg-7 col-xs-12 col-xl-6 col-md-10">
                                        <div class="submit-field">
                                            <h5>Pesquise um usuário:</h5>
                                            <input type="text" class="with-border margin-bottom-0" placeholder="Escreva aqui.." name="pesquisa" v-model="form.pesquisa">
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-2 col-xs-4 hidden-xs hidden-md">
                                        <div class="submit-field">
                                            <div class="hidden-xs clearfix" style="margin-top: 27px;"></div>
                                            <button class="button small color-primary">
                                                <i class="material-icons">search</i>
                                                Pesquisar
                                            </button>                                          
                                        </div>
                                    </div>
                                    <div class="col-xs-8 margin-bottom-20 padding-top-12 col-md-7">
                                        <small>{{data.total}} resultado(s) encontrado(s).</small>
                                    </div>

                                    <div class="col-lg-3 col-md-3 col-xs-4 hidden-xl hidden-lg" style="text-align: right;">
                                        <div class="submit-field">
                                            <div class="hidden-xl hidden-lg margin-top-10"></div>
                                            <div class="hidden-xs hidden-md clearfix" style="margin-top: 32px;"></div>
                                            <button class="button small color-primary">
                                                <i class="material-icons">search</i>
                                                Pesquisar
                                            </button>                                          
                                        </div>
                                    </div>
                                </div>
                                <div class="hidden-sm hidden-xl hidden-lg margin-top-20"></div>
                            </form> 

                            <div v-show="data.itens.length == 0 && loaded" class="job-overview empty">
                                <div class="job-overview-inner">
                                    <center>
                                        <i class="material-icons big">mood_bad</i>
                                        <p>Nenhum resultado encontrado.</p>
                                    </center>
                                </div>      
                            </div>

                            <div class="table-scroll" style="overflow-x: scroll;" v-show="data.itens.length > 0">

                                <table class="table table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 1px; width: 1px;">
                                            ID
                                        </th>
                                        <th style="min-width: 200px;">
                                            Nome
                                        </th>
                                        <th style="min-width: 90px; width: 90px;" v-if="$router.currentRoute.name == 'UsuariosGeral'">
                                            Tipo
                                        </th>                                        
                                        <th style="min-width: 200px; width: 200px;">
                                            E-mail
                                        </th>                                                                                                           
                                        <th style="min-width: 130px; width: 130px;">
                                            Cadastro
                                        </th>     
                                        <th style="min-width: 120px; width: 120px;" v-if="$root.user.tipo == 'admin'">
                                            Ações
                                        </th>                                                                     
                                    </thead>
                                    <tbody>   

                                        <tr v-for="item in data.itens">
                                            <td data-label="">
                                                <router-link :to="{'name': $router.currentRoute.meta.options.editarBotaoNome, 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                    <span class="hidden-xl hidden-lg">ID: </span>{{item.id}}
                                                </router-link>
                                            </td>
                                            <td data-label="Nome">
                                                <router-link :to="{'name': $router.currentRoute.meta.options.editarBotaoNome, 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                    <u>{{item.nome}}</u>
                                                </router-link>
                                            </td>
                                            <td data-label="Tipo" v-if="$router.currentRoute.name == 'UsuariosGeral'">
                                                <router-link :to="{'name': $router.currentRoute.meta.options.editarBotaoNome, 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                    <span class="dashboard-status-button color-secondary">
                                                        {{(item.tipo == 'admin' ? 'Administrador': '')}}
                                                        {{(item.tipo == 'profissional' ? 'Profissional': '')}}
                                                        {{(item.tipo == 'marketing' ? 'Marketing': '')}}
                                                        {{(item.tipo == 'contratante' ? 'Paciente': '')}}
                                                    </span>
                                                </router-link>
                                            </td>                                             
                                            <td data-label="E-mail">
                                                <router-link :to="{'name': $router.currentRoute.meta.options.editarBotaoNome, 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                    {{item.email}}
                                                </router-link>
                                            </td>                     
                                            <td data-label="Cadastro">
                                                <router-link :to="{'name': $router.currentRoute.meta.options.editarBotaoNome, 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                    {{item.datahora | formatDate}}
                                                </router-link>
                                            </td>   
                                            <td data-label="Ações" v-if="$root.user.tipo == 'admin'">
                                                <router-link :to="{'name': $router.currentRoute.meta.options.editarBotaoNome, 'query': {'c': item.cod}}" class="dashboard-status-button gray">
                                                    <i class="material-icons">edit</i>
                                                    Editar
                                                </router-link>
                                                <div class="hidden-xs hidden-md" style="height: 5px;"></div>
                                                <a class="dashboard-status-button gray" v-on:click="del(item.cod)">
                                                    <i class="material-icons">delete</i>
                                                    Apagar
                                                </a>                                                                                      
                                            </td>                                                                                                                                       
                                        </tr>

                                    </tbody>
                                </table>

                                <div class="pagination-container margin-top-60 margin-bottom-60">
                                    <nav class="pagination">
                                        <ul>
                                            <li class="pagination-arrow" v-show="data.page > 1" v-on:click="form.page = (data.page - 1); get(true);">
                                                <a>
                                                    <i class="material-icons">arrow_back</i>
                                                    Anterior
                                                </a>
                                            </li>
                                            <li class="pagination-arrow" v-show="data.page >= 1 && data.page < (data.pages.length)" v-on:click="form.page = (data.page + 1); get(true);">
                                                <a>
                                                    Próxima
                                                    <i class="material-icons">arrow_forward</i>
                                                </a>
                                            </li>    
                                            <br class="hidden-lg hidden-xl hidden-md">                                        
                                            <li v-for="(item, index) in data.pages" v-show="item.show">
                                                <a class="" v-bind:class="{'current-page': item.index == data.page}" v-on:click="form.page = item.index; get(true);">
                                                    {{item.index}}
                                                </a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>                                
                            </div>
                        </div>                    
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Usuarios',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + " " + time;
        }   
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             self.$router.currentRoute.meta.options.tipo,
                "page":             1,
                "pesquisa":         ""
            }              
        }
    },
    methods: {
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                if (self.data.pesquisa != self.form.pesquisa) {
                    self.form.page  = 1;
                }

                axios.get("api/usuarios.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    self.loaded = true;
                    loading.hide();
                    self.$root.scrollTop();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/usuarios.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    self.get();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }        
    },
    created: function() {
        var self = this;
        self.get();
    },
    mounted: function() {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Usuarios.vue